import type { Store } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { css } from "../../../../styled-system/css";
import { IconImage } from "../../../components/icon-image";

type StoreBlockProps = {
  reverse?: boolean;
  size?: "default" | "compact" | "large";
  store: Store;
};

export default function StoreBlock({
  reverse,
  size = "default",
  store,
}: StoreBlockProps) {
  return (
    <div
      className={css({
        display: "flex",
        gap: size === "default" ? "16px" : "8px",
        alignItems: "center",
        px: size === "large" ? "8px" : undefined,
      })}
    >
      <IconImage
        src={store.iconUrl}
        alt={store.name}
        size={48}
        className={size === "large" ? { flexShrink: 0 } : undefined}
      />
      <h2
        className={css({
          fontSize:
            size === "large" ? "24px" : size === "compact" ? "18px" : "20px",
          color: reverse ? "white" : "text.primary",
          fontWeight: size === "large" ? "400" : "600",
          lineHeight: "1.35",
          wordBreak: "break-word",
          minWidth: 0,
          flex: size === "large" ? "1" : undefined,
          display: size === "large" ? "-webkit-box" : undefined,
          WebkitBoxOrient: size === "large" ? "vertical" : undefined,
          WebkitLineClamp: size === "large" ? 2 : undefined,
          overflow: size === "large" ? "hidden" : undefined,
        })}
      >
        {store?.name}
      </h2>
    </div>
  );
}
